const decode = ({ value }) => {
  if(!value)
    return null;

  return Buffer.from(value, 'base64').toString();
}

export default decode;
